unit NetInstrumentItemListType;

interface

uses
  NetInstrumentItemType;

type
  TNetInstrumentItemListType = array of TNetInstrumentItemType;

implementation

end.
